import { useField } from 'react-final-form';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 2px solid #cccccc;
  padding: 8px 12px 8px 24px;
  border-radius: 20px;
  border-top-left-radius: 0;
  color: #66666699;
  font-size: 12px;
  line-height: 100%;
`;

type Props = {
  fieldId: string;
};

export const OriginalText: React.FC<Props> = ({ fieldId }) => {
  const {
    input: { value }
  } = useField(`${fieldId}.original_message`);
  return <Wrapper>{value}</Wrapper>;
};
